import { render, staticRenderFns } from "./spinner-test-summary.vue?vue&type=template&id=0af16820&"
import script from "./spinner-test-summary.vue?vue&type=script&lang=js&"
export * from "./spinner-test-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports